<template>
    <div>
        <!-- 資料與他人重複提示燈箱 -->
        <PopupCheckBDP
            v-model:postApiCheckBDP="postApiCheckBDP"
            @confirm="storeInfo"
            @close="closeIsLoading"
        />
        <!-- 驗證錯誤訊息燈箱 -->
        <PopupBase
            v-model:visiblePopup="visiblePopup"
            :params="{
                title: '請調整資料內容',
                confirmButton: '確認',
            }"
            @confirm="closePopup"
        >
            <template #content>
                <ul v-if="errorTip">
                    <li>
                        {{ errorTip }}
                    </li>
                </ul>
                <ul
                    v-if="errorResponse.length>0"
                    class="space-y-2 list-decimal ml-6"
                >
                    <li
                        v-for="(item, index) in errorResponse"
                        :key="index"
                    >
                        <div v-if="item.errors?.length>0">
                            <p>{{ `${item.block}：` }}</p>
                            <ul
                                v-for="(msg , idx) in item.errors"
                                :key="idx"
                            >
                                <li>{{ msg }}</li>
                            </ul>
                        </div>
                        <p v-else>
                            {{ item.errorMessage }}
                        </p>
                    </li>
                </ul>
            </template>
        </PopupBase>

        <div
            class="md:bg-white md:px-5 lg:px-7 rounded-b-lg"
            :class="[code==='BD'?'md:pt-4 md:pb-12 rounded-t-lg md:my-4':'md:pb-4 md:pt-6']"
        >
            <Title
                v-if="code==='BD'"
                style-code-page
                :text="$route.meta.pageTitle"
            />
            <div class="text-base xs:text-lg">
                <ul class="text-tip">
                    <template v-if="code==='BC'">
                        <li>
                            本次申請變更之要保人行動電話及E-mail，將同時更新以您為要保人於本公司所投保之所有個人險有效及停效保單。
                            <!-- 本次申請變更之要保人行動電話及E-mail，將同時更新以您為要保人於本公司所投保之所有個人險(含MG系列保單)有效及停效保單。 -->
                        </li>
                    </template>
                    <template v-else>
                        <li>
                            本次申請變更內容，將同時更新以您為要保人於本公司所投保之所有個人險有效及停效保單。
                        </li>
                        <li>
                            除應送達要保人住所之文件外，本契約繳費通知及其他有關文件之寄送，以收費/聯絡地址為準。
                        </li>
                    </template>
                </ul>
                <fieldset
                    v-for="(item, idx) in users"
                    :key="item.id"
                    class="last:border-b last:mb-8"
                >
                    <InputForm
                        v-if="item.id==='insuredInfo'?isShowInsuredBlock:true"
                        v-model:isOpen="item.isOpen"
                        :title="item.title"
                        class="border-t"
                        :idx="idx"
                        :is-loading-data="isLoadingData"
                        @resetValues="resetValues"
                    >
                        <template #data>
                            <div
                                v-if="isLoadingData"
                                class="overflow-hidden"
                            >
                                <SkeletonSentence class="w-4/5 md:w-1/3" />
                                <SkeletonSentence class="w-3/5 md:w-1/4" />
                            </div>
                            <!-- 顯示靜態資料區 -->
                            <ul
                                v-else-if="!item.isOpen && !isLoadingData"
                                class="space-y-2 pb-2 md:min-h-[2rem]"
                            >
                                <template v-if="isEmptyData(initialData[idx])">
                                    <li>
                                        系統無資料，如需增加，請點選變更。
                                    </li>
                                </template>
                                <template v-else>
                                    <li v-if="initialData[idx].city">
                                        {{ initialData[idx].city }}{{ initialData[idx].cityArea }}{{ initialData[idx].address }}
                                    </li>
                                    <li v-if="initialData[idx].tel">
                                        <span v-if="initialData[idx].telAreaCode">
                                            {{ `${initialData[idx].telAreaCode}-` }}
                                        </span>
                                        <span>
                                            {{ initialData[idx].tel }}
                                        </span>
                                        <span v-if="initialData[idx].telExt">
                                            分機 {{ initialData[idx].telExt }}
                                        </span>
                                    </li>
                                    <li v-if="initialData[idx].mobile">
                                        {{ getMobileCountry(initialData[idx].mobileCountry) }} {{ initialData[idx].mobile }}
                                    </li>
                                    <li
                                        v-if="initialData[idx].email"
                                        class="break-all"
                                    >
                                        {{ initialData[idx].email }}
                                    </li>
                                </template>
                            </ul>
                        </template>
                        <template #inputs>
                            <!-- 被保險人區塊不顯示時，要隱藏同被保險人 -->
                            <div
                                v-if="item.radio && (item.id==='chargeInfo'?isShowInsuredBlock:true)"
                                class="flex flex-wrap md:flex-nowrap mb-3"
                            >
                                <Radio
                                    v-if="item.radio"
                                    v-model:checked-value="item.radio"
                                    value="n"
                                    :name="`radioSelect${idx}`"
                                    text="輸入住所/電話"
                                    class="pr-5 mb-1.5 md:m-0"
                                    @change="resetAddress(idx, 'n')"
                                />
                                <Radio
                                    v-if="item.radio && isShowInsuredBlock"
                                    v-model:checked-value="item.radio"
                                    value="insuredInfo"
                                    :name="`radioSelect${idx}`"
                                    text="同被保險人住所"
                                    class="pr-5 mb-1.5 md:m-0"
                                    @change="resetAddress(idx, 'insuredInfo')"
                                />
                                <Radio
                                    v-if="item.id==='applicantInfo'"
                                    v-model:checked-value="item.radio"
                                    value="chargeInfo"
                                    :name="`radioSelect${idx}`"
                                    text="同收費地址"
                                    class="pr-5 mb-1.5 md:m-0"
                                    @change="resetAddress(idx, 'chargeInfo' )"
                                />
                            </div>
                            <transition
                                name="expand"
                                mode="out-in"
                            >
                                <div
                                    v-if="Object.keys(users[idx]).includes('address') && (users[idx].radio === 'n'|| !users[idx].radio)"
                                    class=" gray-dashed"
                                >
                                    <div class="pb-2.5 flex flex-wrap">
                                        <ul class="text-tip w-full mb-2">
                                            <li>不得為郵政信箱</li>
                                        </ul>
                                        <div class="mr-2 mb-2 md:mb-0 max-w-[12.5rem] w-[calc(50%-0.25rem)] md:w-[22%]">
                                            <Multiselect
                                                v-model="item.city"
                                                class="select-base"
                                                :options="cityOptions"
                                                placeholder="請選擇"
                                                :can-clear="false"
                                                :can-deselect="false"
                                                @select="setCityValue(item)"
                                            />
                                            <div class="error-msg">
                                                {{ item.errors?.city }}
                                            </div>
                                        </div>

                                        <div class="mb-2 md:mb-0 max-w-[12.5rem] w-[calc(50%-0.25rem)] md:w-[22%]">
                                            <Multiselect
                                                v-model="item.cityArea"
                                                class="select-base"
                                                track-by="area"
                                                label="area"
                                                :options="countyOptions[item.city]"
                                                placeholder="請選擇"
                                                :disabled="!item.city"
                                                :can-clear="false"
                                                :searchable="false"
                                                :can-deselect="false"
                                                @select="setCityArea(item)"
                                            />
                                            <div class="error-msg">
                                                {{ item.errors?.cityArea }}
                                            </div>
                                        </div>
                                        <div class="w-full md:w-[52%] md:ml-2 md:max-w-[25.1875rem]">
                                            <input
                                                v-model.trim="item.address"
                                                :disabled="!item.cityArea"
                                                inputmode="text"
                                                autocomplete="off"
                                                class="input-base"
                                                maxlength="62"
                                                placeholder="地址"
                                                @blur="validateAddress(item)"
                                            >
                                            <div class="error-msg">
                                                {{ item.errors?.address }}
                                            </div>
                                        </div>
                                        <div class="text-gray-400 text-sm mb-1 mt-1 md:mt-2">
                                            路、段前請以大寫國字輸入，如：一、二；鄰、巷、弄、號、樓、室前請以阿拉伯數字輸入，如：1、2。
                                        </div>
                                    </div>
                                </div>
                            </transition>
                            <div
                                v-if="Object.keys(item).includes('telAreaCode')"
                                class="gray-dashed"
                            >
                                <div class="flex flex-nowrap w-full max-w-[22.5rem] mt-1">
                                    <div class="w-[4.1rem] xs:w-[5rem] pr-2 flex-shrink-0 mb-2 xs:mb-0">
                                        <input
                                            v-model.trim="item.telAreaCode"
                                            inputmode="numeric"
                                            autocomplete="off"
                                            class="input-base max-w-[5rem] xs:w-full"
                                            placeholder="區碼"
                                            maxlength="4"
                                            @input="clearTel(item)"
                                            @blur="validateTel(item)"
                                        >
                                    </div>
                                    <div class="flex flex-warp grow">
                                        <input
                                            v-model.trim="item.tel"
                                            inputmode="numeric"
                                            autocomplete="off"
                                            class="input-base xs:w-3/5 xs:grow xs:max-w-[12.5rem] mr-2"
                                            placeholder="電話"
                                            maxlength="8"
                                            :disabled="!item.telAreaCode"
                                            @blur="validateTel(item)"
                                        >
                                        <input
                                            v-model.trim="item.telExt"
                                            inputmode="numeric"
                                            autocomplete="off"
                                            class="input-base w-[4.75rem] xs:w-2/5"
                                            placeholder="分機"
                                            maxlength="6"
                                            :disabled="!item.telAreaCode"
                                            @blur="validateTel(item)"
                                        >
                                    </div>
                                </div>
                                <div class="w-full max-w-[22.5rem] mb-3">
                                    <div class="error-msg">
                                        {{ item.errors?.tel }}
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="Object.keys(item).includes('mobile')"
                                class="gray-dashed"
                            >
                                <div class="flex flex-wrap">
                                    <div class="md:mb-0 mr-2 max-w-[12.5rem] w-[calc(50%-0.25rem)] md:w-[12.5rem]">
                                        <Multiselect
                                            v-model="item.mobileCountry"
                                            class="select-base"
                                            placeholder="國碼"
                                            track-by="text"
                                            label="label"
                                            :options="telCode"
                                            :can-clear="false"
                                            :can-deselect="false"
                                            @select="validateMobile(item)"
                                        />
                                        <div class="error-msg">
                                            {{ item.errors?.mobileCountry }}
                                        </div>
                                    </div>
                                    <div class="md:mr-2 w-[calc(50%-0.25rem)] md:w-auto max-w-[12.5rem]">
                                        <input
                                            v-model.trim="item.mobile"
                                            class="input-base"
                                            inputmode="numeric"
                                            autocomplete="off"
                                            maxlength="11"
                                            type="text"
                                            placeholder="行動電話"
                                            :disabled="!item.mobileCountry"
                                            @blur="validateMobile(item)"
                                        >
                                        <div class="error-msg mb-3">
                                            {{ item.errors?.mobile }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="Object.keys(item).includes('email')"
                                class="gray-dashed"
                            >
                                <div class="flex flex-col items-end sm:flex-row space-x-1 sm:items-baseline">
                                    <div class="w-full sm:w-[calc(100%-190px)] md:w-[52%] md:max-w-[25.1875rem]">
                                        <input
                                            v-model.trim="item.email"
                                            :name="`users[${idx}].email`"
                                            class="input-base"
                                            maxlength="264"
                                            inputmode="email"
                                            autocomplete="off"
                                            type="text"
                                            placeholder="電子信箱"
                                            @input="validateEmail(item)"
                                        >
                                        <div class="error-msg">
                                            {{ item.errors?.email }}
                                        </div>
                                    </div>
                                    <ValidEmail
                                        v-if="item.id!=='insuredInfo' && initialData[idx].email !== item.email"
                                        v-model:isValid="isValid"
                                        v-model:needEmailVerify="needEmailVerify"
                                        :email="item.email"
                                        :isPassCheck="item.errors?.email===''"
                                    />
                                </div>
                            </div>
                        </template>
                    </InputForm>
                </fieldset>
            </div>
        </div>

        <Bottombar>
            <template #right>
                <ButtonNextService v-model:isSubmitOk="isSubmitOk">
                    <button
                        class="btn btn-accent rounded-full"
                        :disabled="!hasChangeData || needValidEmail"
                        @click="onSubmit"
                    >
                        確認
                    </button>
                </ButtonNextService>
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { ref, reactive, toRefs, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { getInfoBCBD, submitBCBD } from '@/apis/BCBD';
import routeName from '@/router/constant.js';
import PopupBase from '@/components/dialogs/Popup.vue';
import Multiselect from '@vueform/multiselect';
import Bottombar from '@/components/layout/Bottombar.vue';
import InputForm from '@/components/collapse/CollapseFrame.vue';
import Title from '@/components/text/Title.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import PopupCheckBDP from '@/components/dialogs/PopupCheckBDP.vue';
import SkeletonSentence from '@/components/skeletons/SkeletonSentence.vue';
import getSelectList from './getSelectList';
import { checkAddress } from '@/utils/rules/checkAddr.js';
import { commonValidMobile, commonValidateTel, commonValidateEmail } from './validate.js';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import ValidEmail from '@/components/dialogs/ValidEmail.vue';

export default {
    components: {
        InputForm,
        Multiselect,
        Bottombar,
        Title,
        Radio,
        PopupBase,
        Loading,
        SkeletonSentence,
        PopupCheckBDP,
        ButtonNextService,
        ValidEmail
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const code = route.meta.code;
        const errorResponse = ref([]);
        const errorTip = ref('');
        const visiblePopup = ref(false);
        const postApiCheckBDP = ref(false);
        const isLoading = ref(false);
        const isLoadingData = ref(false);
        const isSubmitOk = ref(false);

        // 要去保全聯盟練嗎？
        const doAllianceChain = ref(false);
        const storeUserData = ref();
        // 被保險人資料：BD 沒有/ BC 須等api返回才知
        const isShowInsuredBlock = ref(code === 'BC');
        const resData = reactive({
            info: {}
        });

        const isValid = ref(false);
        const needEmailVerify = ref(true);

        /** 燈箱關閉並清空值 */
        const closePopup = () => {
            isLoading.value = false;
            visiblePopup.value = false;
            errorResponse.value = [];
            errorTip.value = '';
        };
        /** 資料重複燈箱關閉 */
        const closeIsLoading = () => {
            isLoading.value = false;
        };

        /** 取得手機國碼  886不用顯示在畫面 */
        const getMobileCountry = (tel) => {
            if (tel === '') return '';
            const telCodeObj = telCode.value.filter(i => i.value === tel);
            const text = telCodeObj[0].value === '886' ? '' : telCodeObj[0].label;
            return text;
        };
        /** 設定city */
        const setCityValue = (item) => {
            item.cityArea = '';
            item.errors.city = '';
            item.errors.cityArea = '';
            item.address = '';
            item.errors.address = '';
        };
        /** 設定cityyArea */
        const setCityArea = (item) => {
            item.errors.cityArea = '';
            item.address = '';
            item.errors.address = '';
        };
        /** 欄位中文 */
        const fieldNameList = {
            city: '縣市',
            cityArea: '鄉鎮',
            address: '地址',
            telAreaCode: '區碼',
            tel: '電話',
            telExt: '分機',
            mobileCountry: '國碼',
            mobile: '行動電話',
            email: 'E-mail',
        };
        // 判斷系統是否有留存資料
        const isEmptyData = (item) => {
            if (code === 'BC') {
                const i = Object.assign({}, item);
                const keys = Object.keys(fieldNameList);
                let dataList = keys.map(key => {
                    return i[key];
                });
                dataList = dataList.filter(j => j);
                let hasData = '';
                if (i.id === 'mobile') {
                    hasData = Object.values(dataList).join('').trim() === '886';
                } else {
                    hasData = Object.values(dataList).join('').trim() === '';
                }
                return hasData;
            } else return false;
        };

        const users = reactive([
            { id: 'chargeInfo', title: '收費地址/電話', isOpen: false, city: '', cityArea: '', address: '', telAreaCode: '', tel: '', telExt: '', radio: 'n' },
            { id: 'applicantInfo', title: '要保人住所(戶籍地址)/電話', isOpen: false, city: '', cityArea: '', address: '', telAreaCode: '', tel: '', telExt: '', radio: 'n' },
            { id: 'mobile', title: '要保人行動電話', isOpen: false, mobileCountry: '', mobile: '' },
            { id: 'email', title: '要保人E-mail', isOpen: false, email: '' },
        ]);
        const insuredInfo = { id: 'insuredInfo', title: '被保險人住所/電話/E-mail', isOpen: false, city: '', cityArea: '', address: '', telAreaCode: '', tel: '', telExt: '', mobileCountry: '', mobile: '', email: '' };

        const initialData = ref([...JSON.parse(JSON.stringify(users))]);
        const result = computed(() => {
            const vuexData = store.state.services.changeItemsResult;
            return vuexData[`${code}INFO`];
        });
        /** 當次變更有選擇B4申請全部保單  */
        const isB4selectVal1 = computed(() => {
            const index = store.state.services.serviceList.findIndex(i => i.transactionItemNo === 'B4');
            if (index > -1) {
                return store.state.services.changeItemsResult?.B4?.selectVal === '1';
            } else return false;
        });

        const { telCode, countyOptions, cityOptions } = getSelectList(result.value, code);
        const getData = () => {
            isLoadingData.value = true;
            getInfoBCBD(code).then(res => {
                // 被保人區塊資訊 insuredInfo // 收費區塊資訊 chargeInfo
                // 要保人區塊資訊 applicantInfo // 要保人行動電話 mobile // 要保人Email email
                // 必填欄位：要保人地址/手機/信箱/收費地址，其他如果系統已有資料，該欄位就會變成必填
                const resInfo = res.data;
                resInfo.mobile = {
                    id: 'mobile',
                    mobileCountry: resInfo.mobileCountry,
                    mobile: resInfo.mobile,
                };
                resInfo.email = {
                    id: 'email',
                    email: resInfo.email,
                };
                resData.info = resInfo;

                // 是否顯示被保險人資料區塊
                isShowInsuredBlock.value = resInfo.insuredAuth;
                if (isShowInsuredBlock.value) {
                    users.unshift(insuredInfo);
                }
                // 預設資料
                users.forEach((item) => {
                    const keys = Object.keys(item);
                    keys.forEach(k => {
                        item[k] = resInfo[item.id] && resInfo[item.id][k] ? resInfo[item.id][k] : item[k];
                    });

                    item.errors = {};
                    if (code === 'BC') {
                        if (item.id === 'mobile') {
                            item.requiredList = {
                                mobile: true,
                            };
                            if (!item.mobile && !item.mobileCountry) {
                                item.mobileCountry = '886';
                            }
                        } else if (item.id === 'email') {
                            item.requiredList = {
                                email: true,
                            };
                        } else if (item.id === 'insuredInfo') {
                            item.requiredList = {
                                address: item.address || false,
                                tel: item.tel || false,
                                mobile: item.mobile || false,
                                email: item.email || false,
                            };
                            if (!item.requiredList.mobile) {
                                item.mobileCountry = '';
                            }
                        } else {
                            item.requiredList = {
                                address: true,
                                tel: item.tel || false,
                            };
                        }
                    } else {
                        item.requiredList = {
                            address: false,
                            tel: false,
                            mobile: false,
                            email: false,
                        };
                    }
                });
                initialData.value = [...JSON.parse(JSON.stringify(users))];

                validateForm();
            }).finally(() => {
                isLoadingData.value = false;
            });
        };
        // 如果vuex有資料表示是返回修改
        onMounted(() => {
            if (result.value) {
                const { initData, usersData } = result.value;
                initialData.value = [...initData];
                usersData.forEach((item, index) => {
                    users[index] = item;
                    delete users[index].isOpen;
                    delete initData[index].isOpen;
                    const baseValues = Object.values(initData[index]).join('');
                    const comingValues = Object.values(item).join('');
                    users[index].isOpen = baseValues !== comingValues;
                });
            } else {
                getData();
            }
            if (isB4selectVal1.value) {
                users.forEach(i => {
                    if (i.id === 'email') {
                        i.isOpen = true;
                    }
                });
            }
        });
        /** 驗證表單 */
        const validateForm = () => {
            users.forEach((item) => {
                validateAddress(item);
                validateEmail(item);
                validateTel(item);
                validateMobile(item);
            });
        };

        /** validate Address */
        const validateAddress = (item) => {
            // 不用驗證的情況：非必填or 參考別人
            const { address, city, cityArea, radio, requiredList } = item;
            if (radio && radio !== 'n') return;
            if (!requiredList.address) {
                if (!address && !city && !cityArea) return;
            }

            if (city === '' || cityArea === '' || address === '') {
                item.errors.city = item.city === '' ? '請輸入縣市' : '';
                item.errors.cityArea = item.cityArea === '' ? '請輸入鄉鎮' : '';
                item.errors.address = item.address === '' ? '請輸入地址' : '';
            } else {
                const en = /^[^a-zA-Z]+$/.test(item.address);
                if (!en) {
                    item.errors.address = '不接受英文地址，請改以中文輸入';
                } else {
                    const msg = checkAddress(address);
                    const message = msg.msg;
                    item.errors.address = message[0] || '';
                }
            }
        };
        /** validate Email */
        const validateEmail = (item) => {
            const { email, requiredList } = item;
            item.errors.email = commonValidateEmail({ mail: email, isRequired: requiredList.email });
        };

        /** validate Mobile */
        const validateMobile = (item) => {
            const { mobileCountry, mobile, requiredList } = item;
            item.errors.mobile = commonValidMobile({ mobileCountry, mobile, isRequired: requiredList.mobile });
        };

        // /** validate 電話號碼 */
        const validateTel = (item) => {
            const { telAreaCode, tel, telExt, requiredList } = item;
            item.errors.tel = commonValidateTel({ telAreaCode, tel, telExt, isRequired: requiredList.tel });
        };

        /** 切換radio時 地址reset */
        const resetAddress = (idx, radioVal) => {
            users[idx].radio = radioVal;
            if (radioVal !== 'n') {
                const data = initialData.value[idx];
                const columns = ['city', 'cityArea', 'address'];
                columns.forEach(column => {
                    users[idx][column] = data[column];
                    users[idx].errors[column] = '';
                });
            }
        };

        const clearTel = (item) => {
            if (!item.telAreaCode) {
                item.tel = '';
                item.telExt = '';
                item.errors.tel = '';
            }
        };

        /** 取消變更時 區塊資料reset */
        const resetValues = (idx) => {
            const data = initialData.value[idx];
            const keys = Object.keys(data);
            users[idx] = Object.assign({}, data);
            keys.forEach((item) => {
                users[idx][item] = data[item];
                users[idx].errors[item] = '';
            });
            users[idx].isOpen = false;
        };

        /** 判斷是否變更 */
        const hasChangeData = computed(() => {
            const keyList = Object.keys(fieldNameList);
            const radios = users.map(i => i.radio || '');
            const isCopyInsuredInfo = radios.includes('insuredInfo') && radios.includes('chargeInfo');

            const initial = initialData.value.map((item, index) => {
                const columns = ['city', 'cityArea', 'address'];

                let copyData = null;
                if (users[index].radio && users[index].radio !== 'n') {
                    if (isCopyInsuredInfo) {
                        copyData = users.find(j => j.id === 'insuredInfo');
                    } else {
                        copyData = users.find(j => j.id === users[index].radio);
                    }
                }
                const itemKeys = Object.keys(item);
                const mappingKey = itemKeys.filter(k => {
                    return keyList.find(j => j === k);
                });
                let init = '';
                let user = '';
                mappingKey.forEach(m => {
                    init += item[m];
                    const idx = columns.findIndex(i => i === m);
                    if (copyData && idx > -1) {
                        user += copyData[m];
                    } else {
                        user += users[index][m];
                    }
                });
                return init === user;
            });
            const changeList = initial.filter(i => !i);
            return changeList.length > 0;
        });
        const onSubmit = () => {
            isLoading.value = true;
            // 判斷是否變更
            if (!hasChangeData.value) {
                isLoading.value = false;
                return;
            }
            validateForm();
            const { errorList, errorCount } = getErrors();
            if (errorCount > 0) {
                errorResponse.value = errorList;
                visiblePopup.value = true;
                isLoading.value = false;
            } else {
                const usersData = JSON.parse(JSON.stringify(users));

                const radios = usersData.map(i => i.radio || '');
                // 同時選 "同被保險人" 與 "同收費地址" ＝> 同被保險人
                const isCopyInsuredInfo = radios.includes('insuredInfo') && radios.includes('chargeInfo');
                // 組api資料給後端
                const returnData = {};

                usersData.forEach((i) => {
                    let id = i.id;
                    const mobileCountry = i.mobile === '' && i.mobileCountry === '886' ? '' : i.mobileCountry;
                    if (id === 'email') {
                        returnData.email = i.email;
                    } else if (id === 'mobile') {
                        returnData.mobileCountry = mobileCountry;
                        returnData.mobile = i.mobile;
                    } else {
                        // 資料拷貝（同ＸＸＸ地址）
                        if (i.radio && i.radio !== 'n') {
                            let copyData = {};
                            if (isCopyInsuredInfo) {
                                copyData = usersData.find(j => j.id === 'insuredInfo');
                            } else {
                                copyData = usersData.find(j => j.id === i.radio);
                            }
                            const columns = ['city', 'cityArea', 'address'];
                            // 檢查'city', 'cityArea', 'address'三個欄位是否任一未填寫
                            const emptyField = columns.find(column => {
                                return copyData[column] === '';
                            });
                            if (!emptyField) {
                                // 拷貝資料
                                columns.forEach(column => {
                                    i[column] = copyData[column];
                                });
                            } else {
                                // 欄位未填寫完成 跳出提示燈箱
                                const blockname = {
                                    insuredInfo: '被保險人住所',
                                    chargeInfo: '收費地址',
                                    applicantInfo: '要保人住所',
                                };
                                errorTip.value = `【${blockname[i.id]}】勾選同【${blockname[i.radio]}】，【${blockname[i.radio]}】系統無資料，請確認`;
                                visiblePopup.value = true;
                                isLoading.value = false;
                            }
                        }
                        if (id.includes('Info')) {
                            const idAry = id.split('Info');
                            id = idAry[0];
                        }
                        const keyList = Object.keys(fieldNameList);
                        const iKey = Object.keys(i);
                        const mappingKey = iKey.filter(k => {
                            return keyList.find(j => j === k);
                        });
                        const j = {};
                        mappingKey.forEach(m => {
                            j[m] = i[m];
                        });
                        returnData[id] = j;
                    }
                });
                // // 錯誤會將loading關閉 如果還在loading的話 表示繼續執行
                if (isLoading.value) {
                    storeUserData.value = usersData;
                    postData(returnData, usersData);
                }
            }
        };
        const getErrors = () => {
            let errorCount = 0;
            let errorList = users.map(i => {
                let errorMsg = Object.values(i.errors);
                errorMsg = errorMsg.filter(i => i);
                errorCount += errorMsg.length;
                const blockText = users.find(k => k.id === i.id);
                return { block: blockText.title, errors: errorMsg };
            });
            errorList = errorList.filter(i => i.errors.length > 0);
            return { errorList, errorCount };
        };
        /** 確認輸入資料是否與他人重複 */

        const checkInfo = () => {
            isLoading.value = true;
            postApiCheckBDP.value = true;
        };
        const storeInfo = () => {
            const storeData = {
                initData: initialData.value,
                cityList: cityOptions.value,
                countyList: countyOptions.value,
                telCodeList: telCode.value,
                usersData: storeUserData.value,
            };
            store.dispatch('services/setChangeItemsResult', { code: `${code}INFO`, value: storeData });
            switch (code) {
                case 'BC':
                    // 是否經過保全聯盟練
                    // 返回修改 可能會改變是否去保全聯盟練

                    if (doAllianceChain.value) {
                        router.push({ name: routeName.NOTIFY_COMPANIES });
                    } else {
                        // 不經過保全聯盟練
                        store.dispatch('services/setChangeItemsResult', { code, value: {} });

                        isSubmitOk.value = true;
                    }
                    break;
                case 'BD':
                    router.push({ name: routeName.NOTIFY_COMPANIES_BY_USER });
                    break;
                default: break;
            }
        };
        /** submitBCBD api */
        const postData = (returnData) => {
            submitBCBD(code, returnData).then(res => {
                // 經過保全聯盟練
                doAllianceChain.value = res.data?.doAllianceChain;
                checkInfo();
            }).catch((err) => {
                const errData = err.data?.details || [];
                if (errData[0]?.field) {
                    visiblePopup.value = true;
                    errorResponse.value = errData;
                } else {
                    isLoading.value = false;
                }
            });
        };
        /** 判斷變更email需驗證 */
        const needValidEmail = computed(() => {
            let isNeedValidEmail = false;
            let isEquals;
            users.forEach(i => {
                if (i.id === 'email') {
                    isEquals = i.email !== initialData.value.find(j => j.id === 'email')?.email;
                    if (i.isOpen && !isValid.value && isEquals) {
                        isNeedValidEmail = true;
                    }
                }
            });
            return needEmailVerify.value && isNeedValidEmail;
        });
        return {
            ...toRefs(resData.info),
            hasChangeData,
            code,
            validateTel,
            validateEmail,
            validateMobile,
            validateAddress,
            users,
            telCode,
            initialData,
            cityOptions,
            countyOptions,
            onSubmit,
            resetValues,
            resetAddress,
            getMobileCountry,
            errorResponse,
            visiblePopup,
            isLoading,
            isLoadingData,
            // visibleCheckPopup,
            storeInfo,
            setCityValue,
            fieldNameList,
            isEmptyData,
            closePopup,
            errorTip,
            isShowInsuredBlock,
            // checkBDPMessage,
            closeIsLoading,
            setCityArea,
            postApiCheckBDP,
            clearTel,
            isSubmitOk,
            isValid,
            needValidEmail,
            needEmailVerify,
        };
    },
};
</script>

<style lang="scss" scoped>
.error-msg {
    @apply text-right;
}
// pt-3 mt-3.5
.gray-dashed:not(:first-child) {
    @apply border-t border-dashed border-gray-200 pt-3;
}

.expand-leave-active,
.expand-enter-active {
    transition: max-height 0.4s ease-out;
}
.expand-enter-from,
.expand-leave-to {
    max-height: 0;
    overflow: hidden;
}

.expand-enter-to,
.expand-leave-from {
    max-height: 200px;
    overflow: hidden;
}
</style>
